import {
  Backdrop, Container, Input, Paper, Select
  , Dialog, DialogActions, DialogContent, Divider, DialogTitle, Button
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Alert from 'src/components/Alert';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CentralPaper from './CentralPaper';
import CentralPaperDetail from './CentralPaperDetail';
import StorageIcon from '@material-ui/icons/Storage';
import CloseIcon from '@material-ui/icons/Close';
import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  CentralPaperControl: {
    marginTop: theme.spacing(1)
  },
  searchCC: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconCC: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputCC: {
    flexGrow: 1
  },
  searchButtonCC: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdropCC: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  inputAtananCC: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  pageStyleAtananCC: {
    display: 'flex',
    padding: '2px 4px',
  },
}));

const CentralPaperControl = props => {
  const classes = useStyles();
  const [PaperData, setPaperData] = useState([]);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [FilterPaper, setFilterPaper] = useState('');
  const [stateSearchType, setstateSearchType] = useState("FIS_NO");
  const [displayDetail, setDisplayDetail] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [telefonPopup, settelefonPopup] = useState(false);
  const [TelefonlarData, setTelefonlarData] = useState([]);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const SearchPaperDetail = (searchType, searchText) => {

    


    if (searchType === "TELEFON") {
      var Telefonlar = JSON.parse(localStorage.getItem('Telefonlar') || null);


      if (Telefonlar === null) {
        Telefonlar = [];
        Telefonlar.push({
          id: 1,
          Telefon: searchText
        });
      } else {
        const ids = Telefonlar.map(object => {
          return object.id;
        });
        const max = Math.max(...ids);
        var index = Telefonlar.findIndex(obj => obj.Telefon === searchText);
        if (index === -1) {
          Telefonlar.push({
            id: max + 1,
            Telefon: searchText
          });
        }
      }
      localStorage.setItem('Telefonlar', JSON.stringify(Telefonlar));
    }


    setDisplayDetail(false);
    setDetailData({});
    setLoading(true);
    if (searchText.length > 249) {
      setUyariTip("error");
      setUyariAciklama("En fazla 25 adet fiş girebilirsiniz!...");
      setUyari(true);
      setLoading(false);
      return;
    }
    axios.get('/GetArtemisPaperDetail/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/' + searchType + '/' + searchText).then((response) => {
      const PaperCC = response.data;
      setPaperData(PaperCC);
      setLoading(false);
    }).catch(() => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
    });//
  };
  const handleChangeSearchType = (value) => {
    setstateSearchType(value);
    if (value === "TELEFON") {
      setTelefonlarData(JSON.parse(localStorage.getItem('Telefonlar') || null));
    }
  };

  const handleOpenDetail = (Data) => {
    setDetailData(Data);
    setDisplayDetail(true);
  }

  const handleCloseDetail = () => {
    setDetailData({});
    setDisplayDetail(false);
  }

  const settelefonPopupAc = () => {
    setTelefonlarData(JSON.parse(localStorage.getItem('Telefonlar') || null));
    settelefonPopup(true);
  }

  const ChangeFilter = (value) => {
    if (stateSearchType === "TELEFON") {
      value = value?.replaceAll(" ", "")?.replaceAll("+", "")?.replaceAll("(", "")?.replaceAll(")", "")?.replaceAll("-", "");
      if (value.substring(0, 1) === "9") {
        value = value.substring(1, value.length);
      }
      if (value.substring(0, 1) === "0") {
        value = value.substring(1, value.length);
      }
    }

    setFilterPaper(value);
  };

  const ChangeFilter1 = (value) => {
    if (stateSearchType === "TELEFON") {
      value = value.replaceAll(" ", "")?.replaceAll("+", "")?.replaceAll("(", "")?.replaceAll(")", "")?.replaceAll("-", "");
      if (value.substring(0, 1) === "9") {
        value = value.substring(1, value.length);
      }
      if (value.substring(0, 1) === "0") {
        value = value.substring(1, value.length);
      }
    }
    setFilterPaper(value);
    settelefonPopup(false);
  };


  const SetTemizleTelefon = () => {
    localStorage.removeItem('Telefonlar');
    setTelefonlarData(JSON.parse(localStorage.getItem('Telefonlar') || null));
  }




  useEffect(() => {
    const { searchType, searchText } = props.match.params;

    if (searchType && searchText && ["FIS_NO", "ADSOYAD", "TELEFON"].indexOf(searchType) !== -1 && searchText.length > 0) {
      handleChangeSearchType(searchType);
      ChangeFilter(searchText);
      SearchPaperDetail(searchType, searchText);
    }

    // eslint-disable-next-line
  }, [props.match.params]);


  return (
    <Page className={classes.root} title='Fiş Detayları'>
      <Container maxWidth="lg">
        <Header />
        {
          Loading ?
            <Backdrop className={classes.backdropCC} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Paper component="form" elevation={3} className={classes.searchCC}>
          <Select
            native
            value={stateSearchType}
            disableUnderline
            className={classes.searchInputCC}
            onChange={e => handleChangeSearchType(e.target.value)}
            label="AramaTip">
            <option value="FIS_NO">Fiş Numarası ile Arama</option>
            <option value="ADSOYAD">Müşteri Adı Soyadı ile Arama</option>
            <option value="TELEFON">Telefon Numarası ile Arama</option>
          </Select>
        </Paper>
        <br />
        <Paper
          className={classes.searchCC}
          elevation={3}>
          <StorageIcon onClick={() => settelefonPopupAc()} className={classes.searchIconCC} />
          <Divider orientation="vertical" flexItem />
          <Input
            className={classes.searchInputCC}
            disableUnderline
            value={FilterPaper}
            onChange={e => ChangeFilter(e.target.value)}
            placeholder="  Arama yapınız!..."
          />
          <Divider orientation="vertical" flexItem />
          <SearchIcon onClick={() => SearchPaperDetail(stateSearchType, FilterPaper)} className={classes.searchIconCC} />
        </Paper>
        {
          uyari ?
            <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
            : <div></div>
        }
        {displayDetail ?
          <CentralPaperDetail className={classes.CentralPaperControl}
            item={detailData}
            loading={Loading}
            handleCloseDetail={handleCloseDetail}
          />
          :
          PaperData && PaperData.length > 0 &&
          <CentralPaper
            className={classes.CentralPaperControl}
            items={PaperData}
            loading={Loading}
            handleOpenDetail={handleOpenDetail}
          />
        }
      </Container>
      <Dialog
        open={telefonPopup}
        onClose={() => settelefonPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Daha Önce Aranan Telefonlar
        </DialogTitle>
        <DialogContent>

          {(TelefonlarData || []).sort((a, b) => a.id > b.id ? -1 : 1).map(item =>
            <div>
              <br />
              <Button
                color="secondary"
                onClick={() => ChangeFilter1(item.Telefon)}
                variant="contained"
                fullWidth
                endIcon={<PhoneForwardedIcon>Send</PhoneForwardedIcon>}
              >
                {item.Telefon}
              </Button>
              <br />
            </div>

          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetTemizleTelefon()}
            className={classes.button}
            endIcon={<DeleteForeverIcon>Close</DeleteForeverIcon>}
          >
            Temizle
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => settelefonPopup(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>

  );
}


export default CentralPaperControl;
